import api from './index'
// axios
import request from '../utils/request.js'

// 获取公司配置信息
export function getWnSysSet() {
  return request({
    url: api.getWnSysSet,
    method: 'get',
    hideloading: true,

  })
}
// 获取Banner
export function getwnBanner(params) {
  return request({
    url: api.getwnBanner,
    method: 'get',
    params,
    hideloading: true,

  })
}
// 获取资质
export function getwnCompHonor(params) {
  return request({
    url: api.getwnCompHonor,
    method: 'get',
    params,
    hideloading: true,

  })
}
// 新闻
export function getNews(params) {
  return request({
    url: api.getNews,
    method: 'get',
    params,
    hideloading: true,

  })
}
// 新闻详情
export function getByNews(params) {
  return request({
    url: api.getByNews,
    method: 'get',
    params,
    hideloading: true,

  })
}
// 案例
export function getCase(params) {
  return request({
    url: api.getCase,
    method: 'get',
    params,
    hideloading: true,

  })
}
// 案例详情
export function getByCase(params) {
  return request({
    url: api.getByCase,
    method: 'get',
    params,
    hideloading: true,

  })
}
// 合作
export function getInfo(data) {
  return request({
    url: api.getInfo,
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/user.js